import { media, style } from "typestyle";
import colors from "../../styles/colors";
import mediaQueries, { upTo } from "../../styles/mediaQueries";

export const header = style({
  width: "100%",
  background: colors.blue[400],
});

export const container = style(
  {
    maxWidth: 984,
    margin: "0 auto",
    color: "white",
    display: "flex",
    flexDirection: "column",
    padding: "1rem 0.75rem",
    $nest: {
      "&>span:first-child": {
        fontWeight: 600,
      },
    },
  },
  media(upTo(mediaQueries.desktopSmall), {
    maxWidth: 784,
  }),
);
